import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { InsightsGlobalDiagram } from '@/app/(client)/supply-chain-mapping/-components/insights/InsightsGlobalDiagram';
import { useInsightsGlobalDiagram } from '@/app/(client)/supply-chain-mapping/-hooks/useInsightsGlobalDiagram';
import { QueryErrorState } from '@/components/shared/QueryErrorState';
import { useTranslator } from '@/hooks/useTranslator';

const globalDiagramSearch = z.object({
  filters: z
    .union([
      z.string().transform(v => {
        try {
          return JSON.parse(v) as Record<string, string[]>;
        } catch {
          return undefined;
        }
      }),
      z.record(z.string(), z.array(z.string())),
    ])
    .optional(),
});

export const Route = createFileRoute(
  '/(client)/supply-chain-mapping/(pages)/(list)/insights/global-diagram/',
)({
  validateSearch: globalDiagramSearch,
  component: InsightsGlobalDiagramPage,
});

function InsightsGlobalDiagramPage() {
  const { getTranslation: t } = useTranslator({ page: 'supplyChainMapping' });
  const diagram = useInsightsGlobalDiagram();

  if (diagram.isLoading) {
    return (
      <div className='flex items-center justify-center h-64 text-xs text-muted-foreground'>
        {t('insights.globalDiagram.loading')}
      </div>
    );
  }

  if (diagram.error) {
    return (
      <QueryErrorState
        error={diagram.error}
        onRetry={() => diagram.refetch()}
      />
    );
  }

  return <InsightsGlobalDiagram diagram={diagram} />;
}
